<template>
  <v-select
    v-model="model"
    dense
    outlined
    item-text="descricao"
    return-object
    :placeholder="placeholder"
    :label="label"
    :rules="[rules.required]"
    :items="items.filter(item => item.descricao === 'Fretamento')"
    :disabled="disabled"
    multiple
    item-disabled="disable"
  />
</template>

<script>
import enderecoService from '@/services/sit-pedidos/pedido.service'

export default {
  name: 'ServiceAreaSelect',

  props: {
    label: {
      type: String,
      required: true,
    },

    placeholder: {
      type: String,
      required: true,
    },

    value: {
      type: Array,
      default: ()=>([]),
    },

    disabled: {
      type: Boolean,
      default: ()=>(false),
    }
  },

  data: () => ({
    items: [],

    rules: {
      required: value => !!value || "Esse campo deve ser preenchido"
    }
  }),

  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    model(newValue) {
      this.items = this.items.map(item=>{
        return { ...item, disable:  this._verifyDisableItem(item, newValue) }
      })
    }
  },

  mounted(){
    this.load()
  },

  methods: {
    load() {
      enderecoService.servicesList().subscribe((res)=>{
        this.items = res.map((r)=> ({...r, disable: false}))
      })
    },

    _hasComplementItem(value) {
      return value.some(item=>item.descricao==='Complementar')
    },

    _hasNotComplementItem(value) {
      return value.some(item=>item.descricao!=='Complementar')
    },

    _verifyDisableItem(item, newValue) {
      if(item.descricao!=='Complementar' && this._hasComplementItem(newValue)) {
        return true
      }

      if(item.descricao === 'Complementar' && this._hasNotComplementItem(newValue)) {
        return true
      }


      return false
    }
  }
}
</script>
